import React from "react";
import { Modal } from "react-bootstrap";
import TextInput from "../../Common/TextInput";
import Button from "../../Common/Button";
import useChangePasswordModal, { ChangePasswordModalProps } from "./useChangePasswordModal";

function ChangePasswordModal(props: ChangePasswordModalProps) {
    const modalContent = useChangePasswordModal(props);

    return (
        <Modal show={props.show} onHide={modalContent.handleHide}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {props.resources.get("ChangePasswordFor")}: {modalContent.email}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="container">
                <form onSubmit={modalContent.handleSubmitAsync}>
                    <div className="row gy-3 mt-1">
                        <TextInput
                            inputId="change-password-input"
                            labelText={props.resources.get("NewPassword")}
                            onChange={modalContent.handlePasswordChange}
                            readOnly={false}
                            value={modalContent.password}
                            boldLabel={false}
                            containerClassName="col-12"
                            errorMessage={modalContent.passwordError}
                            type="password"
                            autoComplete="new-password"
                        />
                        <TextInput
                            inputId="change-confirm-password-input"
                            labelText={props.resources.get("ConfirmPassword")}
                            onChange={modalContent.handleConfirmPasswordChange}
                            readOnly={false}
                            value={modalContent.confirmPassword}
                            boldLabel={false}
                            containerClassName="col-12 mb-2"
                            errorMessage={modalContent.confirmPasswordError}
                            type="password"
                            autoComplete="new-password"
                        />
                        <div className="col-md-6">
                            <Button
                                type="submit"
                                variant="primary"
                                className="w-100"
                                disabled={modalContent.disableSubmit}
                            >
                                {props.resources.get("SaveChanges")}
                            </Button>
                        </div>
                        <div className="col-md-6">
                            <Button
                                variant="danger"
                                className="w-100"
                                onClick={modalContent.handleHide}
                            >
                                {props.resources.get("Cancel")}
                            </Button>
                        </div>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
}

export default ChangePasswordModal;
